export default __webpack_public_path__ + "web-button.83d37887b7b6b61da5f50e31e9c78e67.png";